export const initialLogTabs = {
    logs: {
      route: "/logs/systemLogs",
      value: "logs"
    },
    genericFilterParamLogs: {
      route: "/logs/genericFilterParamLogs",
      value: "genericFilterParamLogs"
    },
    evaluationLogs: {
      route: "/logs/evaluationLogs",
      value: "evaluationLogs"
    }
  };
